import React, {useEffect, useState} from "react";
import {useSelector, useDispatch} from "react-redux";
import * as actions from '../../../store/actions';
import formatters from "../../../utils/forms/formatters";
import validators from "../../../utils/forms/validators";
import AlertCard from "../../theme/cards/AlertCard";
import Input from "../../theme/forms/Input";


function ResidentialTaxInputForm({ onNoTax }) {
    let inputs = useSelector(state => state.formFlow.inputs)
    let improvements = useSelector(state => state.formFlow.inputs?.improvements || [])
    let optionData = useSelector(state => state.indicativeOptionData)

    let ITCImprovement = useSelector(state => {
        let ITCImp;
        improvements.forEach((imp) => {
            if (ITCImp) return;
            let matchingImp = optionData.improvements.find(d => d.id === imp.id)
            if (matchingImp.tax_benefit_percentage) {
                ITCImp = {...imp, ...matchingImp}
            }

        })
        return ITCImp || {}
    })

    // let [ITCImprovement, setITCImprovement] = useState({})

    let [taxValue, setTaxValue] = useState(0);

    let dispatch = useDispatch();

    let assettype = optionData.assetTypes.find(
        (d) => d.id === +inputs.asset_type
    ) || {};

    let {direct_pay_eligible} = assettype;

    const updateProject = (data) => {
        dispatch(actions.formFlow.updateFormFlowInputs(data))
    }

    const updateITCImprovementInStore = (data) => {
        dispatch(actions.formFlow.updateFormFlowInputs({
            improvements: improvements.map(d => d.id === ITCImprovement.id ?  {...d, ...data} : d)
        }))
    }



    useEffect(() => {

        let tax_v = 0;
        let improvement_value = +ITCImprovement.value

        if (ITCImprovement) {

            if (ITCImprovement.tax_benefit_fixed_subsidy) {
                tax_v += +ITCImprovement.tax_benefit_fixed_subsidy + inputs.additionalGrants;
            }

            if (ITCImprovement.tax_benefit_percentage && !isNaN(improvement_value)) {
                const tax_percentage = (+ITCImprovement.tax_benefit_percentage +
                    (inputs.lowIncomeITCAdderValue || 0) + (inputs.energyITCAdderValue || 0) + (inputs.domesticITCAdderValue || 0))
                tax_v += improvement_value * (tax_percentage / 100);
                updateITCImprovementInStore({tax_benefit_percentage: tax_percentage});

            }
        }

        setTaxValue(tax_v)

        if (tax_v === 0) {
             onNoTax();
        }

    }, [inputs.additionalGrants, inputs.lowIncomeITCAdderValue, inputs.energyITCAdderValue, inputs.domesticITCAdderValue]);


    if (taxValue === 0) {
         return <></>
    }

function ProposalScenarioOption({ selected, disabled, loading, text, onClick }) {
    const getIcon = () => {
      if (loading) return <i className="fas fa-asterisk fa-spin has-text-grey" />;
      if (selected) return <i className="fas fa-check-square has-text-link" />;
      return <i className="far fa-square" />;
    };
  
    return (
      <div
        className={`level category-option mb-1 ${disabled ? "disable" : ""}`}
        onClick={() => {
          if (disabled || loading) return;
          onClick();
        }}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (disabled || loading) return;
          if (e.key === "Enter" || e.key === " ") onClick();
        }}
      >
        <div className="level-left overflow-hidden">
          <div className="level-item">
            <div className="icon">{getIcon()}</div>
          </div>
          <div className="level-item overflow-hidden">
            <p className="text-overflow-fade">{text}</p>
          </div>
        </div>
      </div>
    );
  }

    return (
         <div>
             <div className="box">
                    <p>This residential project qualifies for a Solar Power Agreement (SPA), which could yield a significant discount.  
                        This discount could increase depending on whether the project qualifies for one or both of the “ITC Adders” below.”
                    </p>

                    <p className="mt-2">(Note: the Tesla Solar Roof does not qualify for “Domestically Produced”)
                    <a target="_blank" href="https://blog.cleanfi.com/927-2/" rel="noreferrer"> Read about adders on our knowledge base.</a></p>

             </div>


             <div className="box mt-5">
                  <Input
                    type="select"
                    inputClasses="is-medium is-fullwidth"
                    label="Is this project in a designated energy district?"
                    subLabel={<div>
                        <a
                            href="https://blog.cleanfi.com/is-your-project-in-an-energy-community-for-the-itc-10-adder/"
                            target="_blank" rel="noreferrer"
                        >
                                Read about it and check for yourself
                        </a></div>}
                    options={[
                        {value: 0, display: "This project does not qualify"},
                        {value: 10, display: "This project qualifies"}
                    ]}
                    onChange={v => {
                        updateProject({energyITCAdderValue: +v})
                    }}
                    value={inputs.energyITCAdderValue || 0}
                  />
                 <Input
                     type="select"
                     inputClasses="is-medium is-fullwidth"
                     label="Does this project qualify for the domestically produced good adder?"
                     subLabel={<div>
                         <a
                             href="https://blog.cleanfi.com/927-2/"
                             target="_blank" rel="noreferrer"
                         >
                             Read about it and check for yourself
                         </a></div>}
                     options={[
                         {value: 0, display: "This project does not qualify"},
                         {value: 10, display: "This project qualifies"},
                     ]}
                     onChange={v => {
                         updateProject({domesticITCAdderValue: +v})
                     }}
                     value={inputs.domesticITCAdderValue || 0}
                 />
            </div>

        </div>
    )
}


export default ResidentialTaxInputForm;